import type { FlaggedProductWithRestaurant } from '../../../../../../services/admin/adminService';

// Identity of one flag in the UI. `source` belongs in it: the resolve/known endpoints are keyed by
// (traceId, articleId, productName, source), so a pakbon and a factuur flag on the same product of the
// same email are two distinct flags — without it they collide into one React key and one done-click.
export function aiQtyFlagKey(f: FlaggedProductWithRestaurant): string {
  return `${f.restaurantId}|${f.articleId}|${f.productName}|${f.source ?? 'pakbon'}`;
}
